module.exports = __webpack_public_path__ + "img/crewFamilyXmasParty8.fc86553e.jpg";